import React from 'react';

export const AboutUs = () => {
    return (
        <>
            <h1>AboutUs</h1>
        </>
    );
};
